export const LANDING_GEM = {
  facets: 8,
  period: 9000,
  center: 20,
  table: { y: 9, radius: 8 },
  girdle: { y: 17, radius: 15 },
  culet: { x: 20, y: 33 },
  lightAngle: -0.7,
  goldLevel: 0.55,
  shadowRgb: [92, 54, 10],
  goldRgb: [212, 150, 40],
  shineRgb: [255, 222, 140],
} as const;
